<template>
  <div id="app">
    <SemcogHeader>
      <span class="title" style="line-height: 2em; font-size: 1em;">
        Building Footprints
      </span>
    </SemcogHeader>
    <mainmap/>
  </div>
</template>

<script>
import mainmap from "./components/MainMap";
import SemcogHeader from './components/SemcogHeader.vue';

export default {
  name: 'app',
  components: {
    mainmap, SemcogHeader
  },
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style>
  #app {
    width: 100%;
    height: 100vh;
    display: grid;
    grid-template-rows: max-content auto;
    font-family: Arial, Helvetica, sans-serif;
  }

  @media screen and (max-width: 576px) {
    #app {
      height: initial;
    }
  }

  @media screen {
    .title {
      display: unset;
    }
  }

  @media print {
    @page {
      size: landscape;
    }

    .title {
      display: none;
    }
  }
</style>
